import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Post from '../components/Post'
import Banner from '../components/Banner'
import Loader from '../components/Loader'
import Message from '../components/Message'
import SearchBox from '../components/SearchBox'
import Paginate from '../components/Paginate'
import { listPosts } from '../actions/mediaActions'
import AnimatedPage from '../components/AnimatedPage'
import Masonry from 'react-masonry-css'
import { Helmet } from 'react-helmet-async'


function DisplayScreen({ history }) {
  const dispatch = useDispatch()
  const postList = useSelector(state => state.postList)
  const { error, loading, posts, page, pages } = postList

  let keyword = history.location.search

  useEffect(() => {
    dispatch(listPosts(keyword))
  }, [dispatch, keyword])

  const breakpointColumnsObj = {
    default: 5,
    1200: 4,
    900: 3,
    600: 2,
  }

  return (
    <AnimatedPage>
       <Helmet>
          <title>Annunci & novità – RayquazaITA</title>
          <meta name="description" content="Ultimi annunci, aggiornamenti e novità da RayquazaITA sul mondo Pokémon TCG Pocket." />
        </Helmet>
      <div>
        <Banner
          src="/static/images/banner.png"
          link="https://t.me/+lcYksKUQBOU1MWM8"
        />
         <Banner
          src="/static/images/minibanner.png"
          to="/post/4"
        />
        <h1 className="mt-5">Annunci & novità</h1>
        <SearchBox basePath="/home"/>
        {loading ? <Loader />
          : error ? <Message variant="danger">{error}</Message>
          : posts.length === 0 ? <Message variant="info">Nessun articolo pubblicato ancora.</Message>
          :
          <div>
            <Masonry
              breakpointCols={breakpointColumnsObj}
              className="my-masonry-grid"
              columnClassName="my-masonry-grid_column"
            >
              {posts.map(article => (
                <div key={article._id} className="masonry-item">
                  <Post article={article} />
                </div>
              ))}
            </Masonry>
            <Paginate page={page} pages={pages} keyword={keyword} basePath="/home"/>
          </div>
        }
      </div>
    </AnimatedPage>
  )
}

export default DisplayScreen